import React from 'react';
import './index.css';

/**
 * Loader component that renders a spinner and loading text
 * used to indicate loading state.
 */
const Loader = () => (
  <div className='loading-container'>
    <div className='loading-spinner' />
    <p>Loading...</p>
  </div>
);

export default Loader;
